import {
  BlockType,
  PodtPreparationScreenInput,
  PodtTargetCategoryInput,
  TestStatus,
  TextAlignment,
} from '../../../../API';
import { PodtaCreatorState } from './types';
import {
  createDefaultFontStyle,
  createDefaultStyle,
  createEmptyDefaultFixation,
  createEmptyKeyboardSettings,
  createEmptyMediaItemSnapshot,
  createWeightedStyledTextInput,
} from '../../testAdmin/testEditor/initialEditorStates';
import { Podta } from '../types';
import templates from './templates/at-tempaltes';

const createEmptyLabeledStimuliPool = (): PodtTargetCategoryInput => ({
  label: '',
  practiceStimuliPool: {
    dangerousStimuli: [],
    nonDangerousStimuli: [],
  },
  testStimuliPool: {
    dangerousStimuli: [],
    nonDangerousStimuli: [],
  },
});

export const getDefaultPreparationScreen = (): PodtPreparationScreenInput => ({
  screen: { desktop: '' },
  interval: 500,
});

export const podtaTemplates: Podta[] = templates;

export const InitialPodtaCreatorState: PodtaCreatorState = {
  startLabel: 'Start',
  nextLabel: 'Next',
  finishLabel: 'Finish',
  name: '',
  description: '',
  scenes: {
    intervalConfig: {
      min: 500,
      max: 1000,
      stepSize: 100,
    },
    maxAmountScenesPerTrial: 4,
    scenes: [],
  },
  targets: [createEmptyLabeledStimuliPool()],
  counterbalancing: true,
  probabilityWithoutReplacement: true,
  fixation: createEmptyDefaultFixation(),
  response: {
    fontStyle: createDefaultFontStyle(TextAlignment.CENTER),
    timeout: 850,
    active: createEmptyMediaItemSnapshot(),
    passive: createEmptyMediaItemSnapshot(),
  },
  interTrialInterval: 3000,
  keyboard: createEmptyKeyboardSettings(),
  instructions: {
    desktop: '',
  },
  trialFeedback: {
    correctRejectionText: createWeightedStyledTextInput(
      'Gute Entscheidung!',
      5,
    ),
    hitText: createWeightedStyledTextInput('Richtig ausgewichen!', 10),
    missText: createWeightedStyledTextInput('Sie wurden verletzt!!!', -40),
    falseAlarmText: createWeightedStyledTextInput(
      'Sie haben die Seite umsonst gewechselt!',
      -20,
    ),
    noResponseText: createWeightedStyledTextInput('Zu langsam', -10),
  },
  blocks: [
    {
      index: 0,
      name: '',
      instructions: {
        desktop: '',
      },
      amountTrials: 20,
      preparationScreen: getDefaultPreparationScreen(),
      type: BlockType.NON_PRACTICE,
    },
  ],
  style: createDefaultStyle(),
  status: TestStatus.DRAFT,
};
